var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"open fs32"},[_c('div',[_vm._v("开启微信推送")]),_c('div',[_c('van-switch',{staticClass:"switch",attrs:{"active-value":1,"inactive-value":0,"active-color":"#1989fa","inactive-color":"#ccc","size":"24"},on:{"change":_vm.handleSwitch},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }